import { ResponsiveModal } from '@src/components/ResponsiveModal';
import { gatewayIcon, PurchaseDetails } from '../../Billing';
import { useState } from 'react';
import { Order } from '@src/services/order/orderApiSliceTypes';
import { PaymentStatus } from '@src/types/payment';
import { PaymentResultBase } from './PaymentResultBase';
import { Button } from 'antd';

export function OrderPaymentResult({
  orderData,
  status,
}: {
  orderData: Order;
  status?: PaymentStatus;
}) {
  const [showOrderDetails, setShowOrderDetails] = useState(false);

  return (
    <>
      <PaymentResultBase
        status={status}
        idLabel='Order ID:'
        idValue={orderData.code}
        amount={orderData.finalAmount}
        currency={orderData.currency}
        time={orderData.createdAt}
        provider={orderData?.gateway && gatewayIcon[orderData.gateway]}
        extraContent={
          status === 'success' && (
            <Button
              onClick={() => setShowOrderDetails(true)}
              className='w-full !py-3 h-auto rounded-lg btn-secondary border-2'
              variant='outlined'
            >
              View eSIM Details
            </Button>
          )
        }
      />

      <ResponsiveModal
        title='Purchase details'
        isOpen={showOrderDetails}
        onClose={() => setShowOrderDetails(false)}
        content={<PurchaseDetails orderId={orderData.id} />}
      />
    </>
  );
}
